// Test variable
export default {
  usedTime: "00:00:00",
  usedTimeMS: 0,
  correctAnswers: 0,
  currentAnswer: 1,
  responses: {},
};
